import React from 'react';
import PropTypes from 'prop-types';

const Formik = ({
  field,
  form,
  title,
  required,
  ...props
}) => (
  <div className="select-field">
    { title && <div className="select-field__label">{title}</div> }
    <select {...field} {...props} />
    { required && <span className="select-field__required">*</span> }
    { form && form.touched[field.name] && form.errors[field.name] &&
      <div className="select-field__error">{ form.errors[field.name] }</div>}
  </div>
);

Formik.propTypes = {
  field: PropTypes.string,
  form: PropTypes.shape({}),
  title: PropTypes.string,
  required: PropTypes.bool,
};

export default Formik;



// WEBPACK FOOTER //
// ./src/components/SelectField/Formik.jsx